<template>
  <form id="search-form" @submit.prevent="onSearch">
    <section id="search-toolbar">
      <section class="search-categories">
        <ejs-dropdownlist id="search-dropdown" :dataSource='categories' :fields='categoryFields' v-model="searchCategory" :enableRtl="isRtl"/>
      </section>
      <section class="search-input e-input-group">
        <input v-model="searchText" ref="searchField" class="e-input" name="search" type="text" :placeholder="strings.placeholder" :enableRtl="isRtl" @keyup="escMonitor" autofocus spellcheck="false"/>
        <button type="submit" class="search-button e-input-group-icon e-icons" tabindex="-1"/>
      </section>
    </section>
  </form>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { TextBoxPlugin, FormValidator } from '@syncfusion/ej2-vue-inputs'
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns'
import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons'
import { enableRipple } from '@syncfusion/ej2-base'
import { CONST } from '@/utils/constants'

Vue.use(DropDownListPlugin)
Vue.use(TextBoxPlugin)
Vue.use(ButtonPlugin)
enableRipple(true)
const minSearchLength = CONST.SearchSettings.minSearchTermLength

export default {
  data () {
    return {
      searchText: '',
      searchCategory: '',
      categoryFields: { text: 'LocalizedName', value: 'Name' },
      strings: {
        placeholder: this.translate('search placeholder')
      },
      validation: {
        rules: {
          search: {
            required: [true, this.translate('input value required')],
            minLength: [minSearchLength, this.translate('input value min length error', { count: minSearchLength })]
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'search/isLoading',
      params: 'search/params',
      isRtl: 'i18n/isRtl',
      showSearchResults: 'search/showSearchResults'
    }),
    categories () {
      // This translates the categories to Localized names but keeps the actual category name for API calls
      const localizedCategories = [{ LocalizedName: this.translate('All'), Name: 'All' }]
      const categories = CONST.SearchSettings.defaultFilter.categories
      categories.forEach((category) => localizedCategories.push({ LocalizedName: this.translate(category), Name: category }))
      return localizedCategories
    }
  },
  watch: {
    showSearchResults: function(show) {
      if (!show) this.resetSearch()
    }
  },
  methods: {
    ...mapActions({
      updateSearchResults: 'search/updateSearchResults',
      resetSearchState: 'search/resetState'
    }),
    translate (string, object) {
      return this.$i18n.translate(string, object)
    },
    resetSearch() {
      this.resetSearchState()
      this.searchText = '';
      this.searchCategory = 'All'
      const element = this.$refs.searchField
      element.focus()
    },
    async onSearch () {
      this.validator = new FormValidator('#search-form', this.validation)
      const validationResult = this.validator.validate()
      if (validationResult && !this.isLoading) {
        await this.updateSearchResults({ query: this.searchText, category: this.searchCategory })
      }
    },
    escMonitor (event) {
      if (event.key === 'Escape') {
        this.resetSearch()
      }
    }
  },
  mounted () {
    this.searchCategory = this.params.category || this.categories[0].Name
    this.searchText = this.params.query
    // Autofocus after DOM is Rendered
    Vue.nextTick(() => {
      const element = this.$refs.searchField
      element.focus()
      element.selectionStart = 0
      element.selectionEnd = element.value.length
    })
  }
}
</script>

<style lang="scss">
@import "@/styles/components/common/_search-toolbar.scss";
</style>
